import { render, staticRenderFns } from "./badges.vue?vue&type=template&id=11c28b62&scoped=true&"
import script from "./badges.vue?vue&type=script&lang=js&"
export * from "./badges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c28b62",
  null
  
)

export default component.exports